module.exports = __webpack_public_path__ + "static/media/logo_menu.63ef2e3c.png";